import axios from 'axios'
import globalConfig from '../config/globle.config'

//创造一个axios的实例
const service = axios.create({
  baseURL: globalConfig.rootUrl,
  timeout: 60 * 3 * 1000,
  responseType: 'blob',
})

service.interceptors.response.use((res) => {
  console.log('filerequest--res')
  return res
})

export default service
